import * as React from 'react';
import {PortfolioChartBase} from 'src/components/PortfolioChartBase';

export const PortfolioChart = () => {
  return <PortfolioChartBase />;
};
